export const orderFormData = () => ({
  inputData: {
    project_id: null,
    order_no: null,
    order_ref_no: null,
    customer_id: null,
    order_amount: null,
    order_date: "",
    billing_address: "",
    shipping_address: "",
    address: "",
    pan_no: null,
    gst_no: null,
    remark: null,
    is_active: true,
    created_by: 1,
    updated_by: 1,

    orderPaymentDetails: [
      {
        stage_id: null,
        percentage: null,
        date: null,
        is_active: true,
      },
    ],
    orderItemDetails: [
      {
        item_id: null,
        qty: null,
        amount: null,
        unit_rate: null,
        gst_percentage: null,
        description: null,
        customer_desc: null,
        type: 2,
        buy_item_details: [
          {
            item_code: null,
            item_id: null,
            item_desc: null,
            uom: null,
            qty: null,
          },
        ],
        is_active: true,
      },
    ],
    order_documents: [
      {
        id: undefined,
        document: null,
        file: null,
        is_active: true,
      },
    ],
  },
});

export const createPageData = () => {
  const payload = {
    modelName: "orders",
    whereCondition: {
      is_active: true,
    },
    relation: [
      {
        modelName: "order_payment_details",
        moduleAs: "orderPaymentDetails",
        foreignKey: "order_id",
      },
      {
        modelName: "order_items",
        moduleAs: "orderItemDetails",
        foreignKey: "order_id",
      },
      {
        modelName: "order_documents",
        moduleAs: "order_documents",
        foreignKey: "order_id",
      },
    ],
  };

  const navigatePage = { back: "/order-list" };

  const headerName = "Order";

  const validationType = "OrderCreate";
  const createEndpoint = "/createOrder";
  const getEndpoint = "/getOrderByID";

  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    getEndpoint,
  };
};

export const exportPageData = {
  data: {
    modelName: "orders",
    relations: [
      {
        module: "projects",
        moduleAs: "project",
      },
      {
        module: "company_masters",
        moduleAs: "company",
      },
    ],

    search: {
      searchKeyword: "",
      field_name: [
        "project.project_code",
        "order_no",
        "customer.first_name",
        "project.project_name",
      ],
    },
    pagination: { page: 1, pageSize: 100000 },
  },
  fileName: "orderData.xlsx",
};
